import {
  EllipsisWithTooltip,
  LinkBehaviour,
  Stack,
  tokens,
} from '@cast/design-system';
import { RbacMemberKindType } from '@cast/types';

import { ProfileAvatar } from 'components/avatars/ProfileAvatar';

import { EntityList } from './EntityList';
import { ServiceAccountIcon } from './ServiceAccountIcon';
import { Member } from '@cast/features-organization-shared-types';

type MemberListProps = {
  members: Member[];
  showRemoveButton?: boolean;
  onMemberRemoveFromList?: (memberId: string) => void;
  onMemberClick?: (memberId: string) => (event: any) => void;
};

export const MemberList = ({
  members,
  showRemoveButton = true,
  onMemberRemoveFromList,
  onMemberClick,
}: MemberListProps) => {
  return (
    <EntityList<Member>
      items={members}
      renderContent={(member) => {
        const content = (
          <Stack direction="row" alignItems="center" gap={4}>
            {member.kind === RbacMemberKindType.SERVICE_ACCOUNT ? (
              <ServiceAccountIcon size={24} />
            ) : (
              <ProfileAvatar
                name={'name' in member ? member.name : ''}
                email={member.email}
                size="xs"
              />
            )}
            <EllipsisWithTooltip
              TypographyProps={{
                variant: 'P12M',
                noWrap: true,
                width: 450,
                color: tokens.theme.fg.structural.primary,
              }}
              TooltipProps={{
                placement: 'bottom-start',
                arrow: true,
              }}
            >
              {member.kind === RbacMemberKindType.USER
                ? member.email
                : member.name}
            </EllipsisWithTooltip>
          </Stack>
        );
        if (onMemberClick)
          return (
            <LinkBehaviour onClick={onMemberClick(member.id)}>
              {content}
            </LinkBehaviour>
          );
        return content;
      }}
      showRemoveButton={showRemoveButton}
      onRemove={onMemberRemoveFromList}
    />
  );
};
